<template>
  <transition name="fade-slide">
    <div class="product-exist-form">
      <!-- Overlay de carga -->
      <v-overlay v-if="loader" opacity="0.6" color="white" light>
        <div class="text-center">
          <v-progress-circular indeterminate size="48" color="primary" class="mb-3" width="3"></v-progress-circular>
          <div class="text-body-2 font-weight-bold grey--text text--darken-2">Cargando...</div>
        </div>
      </v-overlay>

      <!-- Header de sección -->
      <div class="form-section-header d-flex align-center mb-4">
        <v-avatar color="primary lighten-5" size="40" class="rounded-xl mr-3">
          <v-icon color="primary" size="20">mdi-plus-circle-outline</v-icon>
        </v-avatar>
        <div>
          <div class="text-subtitle-2 font-weight-bold text-slate-800">Agregar Producto</div>
          <div class="text-caption grey--text text--darken-1">Seleccione el método de captura</div>
        </div>
      </div>

      <v-form ref="formAdd" @submit.prevent="check()">

        <!-- Selector de modo con estilo pill -->
        <div class="mode-selector mb-4">
          <div class="mode-pill-wrapper d-flex">
            <button type="button" class="mode-pill-btn" :class="{ 'mode-pill-active': tabMode === 0 }"
              @click="tabMode = 0; focusScanning()">
              <v-icon size="16" class="mr-1">mdi-barcode-scan</v-icon>
              Escáner
            </button>
            <button type="button" class="mode-pill-btn" :class="{ 'mode-pill-active': tabMode === 1 }"
              @click="tabMode = 1">
              <v-icon size="16" class="mr-1">mdi-text-search</v-icon>
              Manual
            </button>
          </div>
        </div>

        <!-- ─── MODO ESCÁNER ─── -->
        <transition name="tab-fade" mode="out-in">
          <div v-if="tabMode === 0" key="scanner" class="scanner-panel">
            <v-card outlined class="rounded-xl scanner-card pa-5">
              <!-- Instrucción -->
              <div class="scanner-instructions d-flex align-start mb-4">
                <v-icon color="blue-grey lighten-1" size="18"
                  class="mt-0 mr-2 flex-shrink-0">mdi-information-outline</v-icon>
                <span class="text-caption text-slate-600 leading-relaxed">
                  Inicie el proceso de escaneo. Si se detiene, haga clic en el campo de texto para reactivar.
                  Para otras acciones, detenga el escaneo primero.
                </span>
              </div>

              <!-- Botón toggle de escaneo -->
              <div class="d-flex align-center mb-4">
                <v-btn v-if="!scanning" @click="startScanning()" color="primary" depressed
                  class="action-btn rounded-lg mr-3">
                  <v-icon left size="18">mdi-play-circle-outline</v-icon>
                  Iniciar Escaneo
                </v-btn>
                <v-btn v-if="scanning" @click="stopScanning()" color="error" outlined
                  class="action-btn rounded-lg mr-3">
                  <v-icon left size="18">mdi-stop-circle-outline</v-icon>
                  Detener Escaneo
                </v-btn>

                <!-- Chip de estado -->
                <transition name="fade">
                  <v-chip v-if="scanning" small :color="'green lighten-5'" text-color="green darken-3"
                    class="font-weight-bold scanner-status-chip">
                    <span class="status-dot mr-1"></span>
                    Activo
                  </v-chip>
                </transition>
              </div>

              <!-- Campos de escaneo -->
              <transition name="slide-down">
                <v-row v-if="scanning" class="ma-0">
                  <v-col cols="12" sm="3" class="pa-1">
                    <div class="field-label mb-1">
                      <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Cantidad</span>
                    </div>
                    <v-text-field v-model="inputCantScanner" @keypress="$pgsHelper.onlyNumber($event, inputCantScanner)"
                      outlined dense rounded hide-details class="custom-input" type="number" min="1"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="9" class="pa-1">
                    <div class="field-label mb-1">
                      <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Código de Barras</span>
                    </div>
                    <v-text-field v-model="inputScanner" v-on:keyup.enter="AddProdByScann()" @focusout="focusScanning()"
                      ref="scanInput" outlined dense rounded hide-details class="custom-input"
                      placeholder="Escanea un código de barras..." prepend-inner-icon="mdi-barcode"></v-text-field>
                  </v-col>
                </v-row>
              </transition>

              <!-- Estado vacío cuando no está escaneando -->
              <div v-if="!scanning"
                class="scanner-idle d-flex flex-column align-center py-4 grey--text text--lighten-1">
                <v-icon size="48" color="grey lighten-3" class="mb-2">mdi-barcode-scan</v-icon>
                <span class="text-caption">Presiona "Iniciar Escaneo" para comenzar</span>
              </div>
            </v-card>
          </div>

          <!-- ─── MODO MANUAL ─── -->
          <div v-else key="manual" class="manual-panel">
            <v-card outlined class="rounded-xl manual-card pa-5">

              <!-- Selector de producto -->
              <div class="mb-1">
                <div class="field-label mb-1">
                  <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Producto</span>
                </div>

                <v-chip v-if="labelBusqueda" small outlined color="primary" class="mb-2">
                  <v-icon left x-small>mdi-filter</v-icon>
                  Filtrando: {{ labelBusqueda }}
                </v-chip>

                <v-autocomplete v-model="producto" :items="comp_prod" item-text="Nombre" item-value="id"
                  :label="labelProducto" outlined dense rounded clearable hide-details="auto" class="custom-input"
                  no-data-text="No se encontraron productos">
                  <!-- Botón de filtro prepend -->
                  <template v-slot:prepend-inner>
                    <v-menu v-model="filterMenu" close-on-content-click offset-y style="z-index: 1000">
                      <template v-slot:activator="{ on, attrs }">
                        <v-badge :content="filtroCounter" color="red" overlap :value="filtroCounter > 0" class="mr-2">
                          <v-btn icon x-small v-bind="attrs" v-on="on" aria-label="Filtrar productos"
                            class="filter-btn">
                            <v-icon size="18">mdi-filter-variant</v-icon>
                          </v-btn>
                        </v-badge>
                      </template>

                      <v-card class="rounded-xl filter-menu-card" width="280">
                        <div class="pa-3 pb-1">
                          <div class="text-caption font-weight-bold text-slate-700 text-uppercase mb-2">Filtrar por tipo
                          </div>
                          <v-chip-group mandatory v-model="filterGroup" class="d-flex flex-wrap" @change="changeFilter">
                            <v-chip v-for="filtro in Filters" :key="filtro.value" :value="filtro.value" outlined small
                              :color="filtro.color" class="ma-1">
                              <v-icon left x-small>{{ filtro.icon }}</v-icon>
                              {{ filtro.label }}
                            </v-chip>
                          </v-chip-group>
                        </div>
                      </v-card>
                    </v-menu>
                  </template>

                  <!-- Item personalizado -->
                  <template v-slot:item="{ item }">
                    <div class="d-flex align-center justify-space-between" style="width:100%">
                      <span class="text-body-2 font-weight-medium text-slate-800">{{ item.Nombre }}</span>
                      <v-chip x-small outlined class="ml-2" :color="getFilterProps(item.Tipo).color">
                        <v-icon left x-small>{{ getFilterProps(item.Tipo).icon }}</v-icon>
                        {{ getFilterProps(item.Tipo).label }}
                      </v-chip>
                    </div>
                  </template>
                </v-autocomplete>
              </div>

              <!-- Info de existencia -->
              <transition name="fade-slide">
                <div v-if="producto" class="exist-info-bar mt-3 d-flex align-center rounded-lg pa-3">
                  <v-icon color="teal darken-1" size="18" class="mr-2">mdi-package-variant-closed</v-icon>
                  <div class="d-flex flex-wrap">
                    <span class="text-caption text-slate-700 mr-3">
                      <span class="grey--text">Stock actual:</span>
                      <strong class="ml-1 teal--text text--darken-1">{{ comp_suggest_price.Stock }} {{ Unidad
                      }}</strong>
                    </span>
                    <span class="text-caption text-slate-700">
                      <span class="grey--text">Precio:</span>
                      <strong class="ml-1">${{ comp_suggest_price.PV }} MXN</strong>
                    </span>
                  </div>
                </div>
              </transition>

              <!-- Presentaciones y cantidad (cuando hay producto seleccionado) -->
              <transition name="fade-slide">
                <div v-if="producto" class="mt-4">
                  <v-divider class="mb-4"></v-divider>

                  <v-row class="ma-0" v-if="presentaciones.length > 0">
                    <v-col cols="12" sm="8" class="pa-1">
                      <div class="field-label mb-1">
                        <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Presentación</span>
                      </div>
                      <v-autocomplete :items="presentacionesGlobal" v-model="selectedPresentacion"
                        label="Seleccione presentación..." item-text="title" item-value="Id" outlined dense rounded
                        hide-details="auto" class="custom-input" prepend-inner-icon="mdi-cube-outline"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" class="pa-1">
                      <div class="field-label mb-1">
                        <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Cantidad</span>
                      </div>
                      <v-text-field v-model="cantidadPres" @keypress="$pgsHelper.onlyNumber($event, cantidadPres)"
                        outlined dense rounded hide-details class="custom-input" type="number" min="1">
                        <template v-slot:append-outer>
                          <v-btn small color="primary" depressed class="calc-btn rounded-lg mt-n2"
                            @click="calcularCantidadTransferir()">
                            <v-icon left size="15">mdi-calculator</v-icon>
                            Calcular
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Cantidad total -->
                  <div class="mt-3 pa-1">
                    <div class="field-label mb-1">
                      <span class="text-caption font-weight-bold text-slate-700 text-uppercase">
                        Cantidad a Transferir ({{ Unidad }})
                      </span>
                    </div>
                    <v-text-field v-model="cantidad" readonly disabled :rules="[...rules.Requerido]" outlined dense
                      rounded hide-details="auto" class="custom-input qty-readonly"></v-text-field>
                  </div>

                  <!-- Botón agregar -->
                  <div class="mt-4 d-flex justify-end">
                    <v-btn @click="checkForm()" color="primary" depressed class="action-btn rounded-lg">
                      <v-icon left size="18">mdi-plus-circle-outline</v-icon>
                      Agregar Producto
                    </v-btn>
                  </div>
                </div>
              </transition>

              <!-- Estado vacío cuando no hay producto -->
              <div v-if="!producto"
                class="empty-state d-flex flex-column align-center py-6 grey--text text--lighten-1 mt-2">
                <v-icon size="40" color="grey lighten-3" class="mb-2">mdi-text-search</v-icon>
                <span class="text-caption text-center">Busca y selecciona un producto<br>para continuar</span>
              </div>

            </v-card>
          </div>
        </transition>
      </v-form>
    </div>
  </transition>
</template>

<style scoped>
/* ── Tokens de color ── */
.text-slate-800 {
  color: #1e293b !important;
}

.text-slate-700 {
  color: #334155 !important;
}

.text-slate-600 {
  color: #475569 !important;
}

/* ── Contenedor principal ── */
.product-exist-form {
  position: relative;
}

/* ── Header ── */
.form-section-header {
  padding-bottom: 4px;
}

/* ── Selector de modo pill ── */
.mode-selector {
  background-color: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
  display: inline-flex;
}

.mode-pill-wrapper {
  gap: 2px;
}

.mode-pill-btn {
  display: inline-flex;
  align-items: center;
  padding: 7px 18px;
  border-radius: 9px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.2px;
  outline: none;
}

.mode-pill-btn:hover {
  background-color: #e2e8f0;
  color: #334155;
}

.mode-pill-active {
  background-color: #ffffff !important;
  color: #3b82f6 !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* ── Scanner card ── */
.scanner-card {
  background-color: #fafcff !important;
  border: 1px solid #dbeafe !important;
}

.scanner-instructions {
  background-color: #eff6ff;
  border-radius: 8px;
  padding: 10px 12px;
}

.scanner-status-chip {
  animation: pulse-chip 2s infinite;
}

.status-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  background-color: #16a34a;
  border-radius: 50%;
  animation: pulse-dot 1.5s infinite;
}

@keyframes pulse-dot {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(0.85);
  }
}

.scanner-idle {
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  padding: 24px;
}

/* ── Manual card ── */
.manual-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
}

/* ── Exist info bar ── */
.exist-info-bar {
  background-color: #f0fdfa;
  border: 1px solid #99f6e4;
}

/* ── Inputs ── */
.custom-input /deep/ .v-input__slot {
  background-color: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.custom-input /deep/ .v-input__slot:focus-within {
  border-color: #3b82f6 !important;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08) !important;
}

.qty-readonly /deep/ .v-input__slot {
  background-color: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
}

/* ── Filter menu card ── */
.filter-menu-card {
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08) !important;
}

.filter-btn {
  color: #64748b !important;
  transition: color 0.2s ease;
}

.filter-btn:hover {
  color: #3b82f6 !important;
}

/* ── Botón Calcular ── */
.calc-btn {
  text-transform: none !important;
  letter-spacing: 0.2px;
  font-weight: 600;
  font-size: 0.8rem !important;
  height: 34px !important;
  padding: 0 12px !important;
  transition: all 0.2s ease;
  box-shadow: 0 1px 4px rgba(59, 130, 246, 0.25) !important;
}

.calc-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.35) !important;
}

/* ── Botón de acción ── */
.action-btn {
  text-transform: none;
  letter-spacing: 0.2px;
  font-weight: 600;
  transition: all 0.2s ease;
  height: 38px !important;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.2) !important;
}

.field-label {
  display: flex;
  align-items: center;
}

/* ── Animaciones ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(-6px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.2s ease;
}

.tab-fade-enter,
.tab-fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter {
  opacity: 0;
  transform: translateY(-8px);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>

<script>
import moment from "moment";

import PresentacionesAYB from "../../../clases/Restaurante/PresentacionesAYB.js";
import { Timestamp } from "firebase/firestore";
export default {
  name: "ProductExistForm",
  components: {
    //ModelSelect,
  },
  props: [
    "edit",
    "dataEdit",
    "loadData",
    "facturasDocument",
    "Origen",
    "productsDocument",
    "defaultOption"
  ],
  data() {
    return {
      inputScanner: "",
      inputCantScanner: 1,
      scanning: false,
      tabMode: 0,
      rules: {
        Requerido: [(value) => !!value || "El campo obligatorio"],
        //CantidadMaxima: [(value) => Number(value) <= Number(this.comp_suggest_price.Stock) || "No se tiene el inventario suficiente " + this.comp_suggest_price.Stock]
      },
      selectedPresentacion: null,
      cantidadPres: 1,
      presentaciones: [],
      Unidad: "",
      provedorSearch: "",
      searchText: "",
      item2: "",
      keyformFactura: 1,
      producto: "",
      presentacionData: null,
      actualExist: 0,
      actualPrice: 0,
      nombre: "",
      codigo: "",
      showModalFactura: false,
      newFactura: "",
      proveedor: " ",
      actualMoneda: "MXN",
      cantidad: 0,
      factura: "",
      newPrice: "",
      precioCompra: "",
      OrigenDestino: "",
      monedaCompra: "USD",
      monedaVenta: "",
      errors: {},
      loader: true,
      facturaNombre: "",
      proveedorNombre: "",
      products: [],
      facturasArray: [],
      proveedorArray: [],
      presentacionesArray: [],

      filterGroup: "todos",
      labelProducto: "Buscar producto...",
      filtroCounter: null,
      labelBusqueda: null,
      filterMenu: false,
      Filters: [
        { label: "Todos", value: "todos", icon: "mdi-filter-outline" },
        {
          label: "Insumos",
          value: "AYB-Insumo",
          icon: "mdi-truck-delivery",
          color: "primary",
        },
        {
          label: "Productos",
          value: "Producto",
          icon: "mdi-cube-outline",
          color: "green",
        },
        {
          label: "Subrecetas",
          value: "AYB-ICompuesto",
          icon: "mdi-flask-outline",
          color: "orange",
        },
      ],
    };
  },
  methods: {
    check(e) {
      if (e) {
        e.preventDefault()
      }
    },
    async getPresentaciones() {

      const firestore = this.$store.getters.getFirebaseApp.firestore
      const data = await firestore
        .queryBuilder("AMC_Presentaciones",
          [
            firestore.where(
              "Tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant
            ),
          ]
        )
      if (data.empty) {
        this.presentacionesArray = [];
      } else {
        let doc = data.docs.map(doc => { return { Id: doc.ref.id, ...doc.data() } });
        this.presentacionesArray = doc
      }
    },
    startScanning() {
      this.scanning = true
      this.focusScanning()
    },
    stopScanning() {
      this.scanning = false
    },
    focusScanning() {
      this.inputScanner = "";
      this.$nextTick(() => {
        this.inputScanner = "";
        /*if (this.$refs.scanInput) {
          this.$refs.scanInput.focus();
        }*/
      });
    },
    AddProdByScann() {
      let doAction = "CREATE"
      this.presentacionData = null
      let existPresentacion = this.$pgsHelper.getById(this.presentacionesArray, "cbr", this.inputScanner)
      if (this.inputScanner == "") {
        return false
      }
      if (existPresentacion) {
        try {
          this.producto = existPresentacion.prd
          this.presentacionData = existPresentacion
          this.presentacionData.cntScanner = Number(this.inputCantScanner)
          this.presentacionData.um = this.Unidad
          this.cantidad = Number(existPresentacion.rdm) * Number(this.inputCantScanner);
          this.getDetail(existPresentacion.prd);
          this.presentacionData.um = this.Unidad
        } catch (e) {
          this.$toast.error("", e)
          console.log(e)
        }
      } else {
        let prod = this.$store.getters.getProductos;
        let productoExistente = this.$pgsHelper.getById(prod, "CodigoBarras", this.inputScanner)
        if (productoExistente) {
          this.producto = productoExistente.id
          this.cantidad = Number(1);
          this.getDetail(productoExistente.id);
          this.presentacionData = {
            Id: "PGR_" + productoExistente.id,
            nom: "UNITARIO",
            um: this.Unidad,
            cntScanner: Number(this.inputCantScanner) * Number(this.inputCantScanner),
            rdm: 1,
            prd: productoExistente.id
          }
        } else {
          this.$toast.error(
            " ", "El codigo de barras no pertenece a un producto o presentación",
            {
              position: 'bottomCenter',
            }
          );
          this.inputScanner = ""
          this.inputCantScanner = 1
          return false
        }
      }

      this.$emit("successData", this.$data, doAction);
      this.$toast.success(
        " ", "Agregado " + this.cantidad + " " + this.Unidad + " de " + this.nombre + " \n Presentacion: " + ((existPresentacion) ? existPresentacion.nom : "Individual"),
        {
          position: 'bottomCenter',
        }
      );


      this.inputScanner = ""
      this.inputCantScanner = 1
      this.cantidad = 0
    },
    calcularCantidadTransferir() {
      let presentacion = this.$pgsHelper.getById(
        this.presentacionesGlobal,
        "Id",
        this.selectedPresentacion
      );

      if (presentacion) {
        this.cantidad = Number(presentacion.rdm) * Number(this.cantidadPres);
      }
    },
    async getPresentacionesByProduct(id) {
      let data = await PresentacionesAYB.getPresentacionByProd(id, true);

      this.presentaciones = data;
    },
    selectExistFactura(data) {
      this.facturasArray = [{ id: data.Id, Nombre: data.Nombre }];
      this.proveedorArray = [{ id: data.ProvId, Nombre: data.ProvNombre }];
      this.factura = data.Id;
      this.provedorSearch = data.ProvId;
    },
    getDetail(productoId) {
      let producto = this.getProductoById(productoId);
      this.actualExist = producto.Existencia;
      this.nombre = producto.Nombre;
      this.actualPrice = producto.Precio;
      this.Unidad = producto?.Extra?.AYB?.UM || "PZA";
      // this.newPrice     = producto.Precio;
      this.codigo = producto.Codigo;
      this.actualMoneda = producto.Moneda;
    },
    getProductoById(code) {
      let prod = this.$store.getters.getProductos;
      let itemIndex = this.$_.findIndex(prod, { id: code });
      if (itemIndex >= 0) {
        return prod[itemIndex];
      }
      return false;
    },
    checkForm() {
      this.presentacionData = null
      let valid = true;
      this.presentacionData = {
        Id: "PGR_" + this.producto,
        nom: "UNITARIO",
        um: this.Unidad,
        cntScanner: 1,
        rdm: this.cantidad,
        prd: this.producto
      }
      if (this.selectedPresentacion) {
        let presentacion = this.$pgsHelper.getById(
          this.presentacionesGlobal,
          "Id",
          this.selectedPresentacion
        );
        if (presentacion) {
          this.presentacionData.Id = presentacion.Id
          this.presentacionData.nom = presentacion.nom
          this.presentacionData.cntScanner = Number(this.cantidadPres)
          this.presentacionData.rdm = presentacion.rdm
        }
      }


      this.errors = [];
      if (this.$refs.formAdd.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }

        this.facturasArray.forEach((element) => {
          if (element.id == this.factura) {
            this.facturaNombre = element.Nombre;
          }
        });

        this.proveedorArray.forEach((element) => {
          if (element.id == this.provedorSearch) {
            this.proveedorNombre = element.Nombre;
          }
        });
        this.$emit("successData", this.$data, doAction);
        this.selectedPresentacion = null
        this.cantidadPres = 0
        this.cantidad = 0
        this.$refs.formAdd.resetValidation()
      }
    },
    changeFilter(label) {
      if (label == "Todos") {
        this.filterGroup = null;
        this.filtroCounter = null;
        this.labelBusqueda = null;
        this.labelProducto = "Buscar producto...";
      } else {
        this.filtroCounter = 1;
        this.labelBusqueda = label;
        this.filterGroup = label;
        this.labelProducto = "Buscar " + label;
        this.producto = "";
      }
    },
    getFilterProps(tipo) {
      const filtro = this.Filters.find(f => f.value === tipo) || {};
      const {
        icon = 'mdi-truck-delivery',
        label = 'Insumo',
        color = 'primary'
      } = filtro;
      return { icon, label, color };
    }
  },
  computed: {
    presentacionesGlobal() {
      let presentaciones = [];
      this.presentaciones.forEach((pres) => {
        let producto = this.$pgsHelper.getById(this.comp_prod, "id", pres.prd);
        pres.title =
          producto.Nombre +
          " - " +
          pres.nom +
          " - " +
          pres.rdm +
          " " +
          (producto.Extra?.AYB?.UM ? producto.Extra?.AYB?.UM : "PZA");

        presentaciones.push(pres);
      });
      return presentaciones;
    },
    comp_suggest_price() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let precio_existencia = "";

      origenes.forEach((origen, index) => {
        if (origen.Origen == this.Origen) {
          this.$pgsHelper.log(origen.Productos);
          this.$pgsHelper.log(this.producto);
          let OrProd = Object.entries(origen.Productos);
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == this.producto) {
              this.$pgsHelper.log("Existencia detectada");
              precio_existencia = oProducto[1];
            }
          });
        }
      });

      let returnData = { PCP: 0, PV: 0, PVP: 0, Stock: 0 };

      if (precio_existencia != "") {
        returnData = precio_existencia;
      }

      return returnData;
    },
    comp_prod() {
      try {
        if (!this.Origen) {
          return [];
        }
        let producto = this.$store.getters.getProductos;
        let origenes = this.$store.getters.getOrigenes;
        let listadoProductos = [];
        producto.forEach((element) => {
          let productoData = this.$pgsHelper.cloneObj(element);
          if (
            productoData.Tipo != "Servicio" &&
            productoData.Tipo != "Producto-NInv" &&
            productoData.Tipo != "AYB-Producto" &&
            productoData.Tipo != "Producto-SSal" &&
            !productoData.Dlat
          ) {
            productoData.selectableProd = this.selectedAll;
            let centroConsumo = this.$pgsHelper.getById(
              origenes,
              "Origen",
              this.Origen
            );
            let productOrigen = null;
            if (centroConsumo) {
              if (centroConsumo.Productos[productoData.id]) {
                productOrigen = centroConsumo.Productos[productoData.id];
                productoData.existencia = Number(productOrigen.Stock) || null;
                productoData.unidad = productoData?.Extra?.AYB?.UM || "PZA";
              }
            }
            if (productoData.existencia >= 0) {
              if (productoData.existencia == 0) {
                productoData.existencia = 0;
              }

            }
            listadoProductos.push(this.$pgsHelper.cloneObj(productoData));
          }
        });
        let productosFiltrados = listadoProductos;

        if (this.filterGroup != "todos") {
          productosFiltrados = listadoProductos.filter((item) => {
            return item.Tipo == this.filterGroup;
          });
        }
        return productosFiltrados;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    comp_fact() {
      let fact = [];
      this.facturasArray.forEach((element) => {
        fact.push({
          value: element.id,
          text: element.Nombre + " - " + element.Proveedor,
        });
      });

      return fact;
    },

    comp_proveedor() {
      let prov = [];
      this.proveedorArray.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
    origenes() {
      let origenes = this.$store.getters.getOrigenes;
      return origenes;
    },
  },
  watch: {
    producto: function (val) {
      this.selectedPresentacion = null
      this.cantidadPres = 0
      this.cantidad = 0
      this.getDetail(val);
      this.getPresentacionesByProduct(val);
    },
    provedorSearch: function (val) {
      this.onSelectProv(val);
    },
  },
  beforeMount: function () { },
  mounted() {
    this.loader = false;
    this.focusScanning()
    this.getPresentaciones()
    if (this.edit) {
      this.nombre = this.dataEdit.Nombre;
    }
    if (this.loadData) {
      this.producto = this.loadData.ProductoId;
    }
    if (this.defaultOption) {
      this.tabMode = this.defaultOption;
    }
  },
};
</script>
